import styled from "styled-components";

export const ColumnLayout = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    flex-direction: row;
  }

  & .column {
    width: 100%;

    &:not(:last-child) {
      margin-bottom: ${({ theme }) => theme.space.lg};
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
      width: 50%;
      &:not(:first-child) {
        padding-left: ${({ theme }) => theme.space.lg};
      }
      &:not(:last-child) {
        margin-bottom: 0;
      }
    }
  }
`;
